// Source media is evaluated when selecting a resource. Re-select only when the
// layout breakpoint changes, including videos inserted by the theme editor.
const desktop = matchMedia('(min-width: 750px)');
desktop.addEventListener('change', () => {
  for (const video of document.querySelectorAll('video[data-testid^="hero-"]')) {
    if (!video.querySelector('source[media]')) continue;
    video.pause();
    video.load();
  }
});
